module.exports = __webpack_public_path__ + "img/icon-twitter.0fe950aa.svg";